var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("vat-lines-settings"))),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.selectedLanguage,
                              callback: function ($$v) {
                                _vm.selectedLanguage = $$v
                              },
                              expression: "selectedLanguage",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-divider"),
                      _c(
                        "w-row",
                        { style: { width: "100%" } },
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vatShifted"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.VatShifted.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.VatShifted.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.VatShifted.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("Vat2ehands"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat2ehands.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat2ehands.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat2ehands.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vat44"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat44.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat44.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat44.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vat45"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat45.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat45.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat45.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vat46"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat46.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat46.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat46.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vat47"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat47.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat47.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat47.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vat47s"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Vat47s.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Vat47s.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Vat47s.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.vatfree"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.VatFree.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.VatFree.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.VatFree.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.tdoc"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.Tdoc.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.Tdoc.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.Tdoc.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.wbtw"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.VatWBTW.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.VatWBTW.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.VatWBTW.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("vat-lines.zeeschepen"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.lines.VatZeeschepen.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.lines.VatZeeschepen.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "lines.VatZeeschepen.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c(
                                "w-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.vatStyleEditorOpen = true
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "font" } })],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-modal",
                            { attrs: { value: _vm.vatStyleEditorOpen } },
                            [
                              _c("app-style-editor", {
                                on: {
                                  close: function ($event) {
                                    _vm.vatStyleEditorOpen = false
                                  },
                                },
                                model: {
                                  value: _vm.lines.VatLinesStyle,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.lines, "VatLinesStyle", $$v)
                                  },
                                  expression: "lines.VatLinesStyle",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }